import React from "react";
import PropTypes from "prop-types";
// import Button from "../../../components/button";
import IconBox from "../../../components/icon-box";
import SectionTitle from "../../../components/section-title";
import HomeData from "../../../data/home.json";

const IconBoxContainer = ({ classOption }) => {
    return (
        <div className={`feature-section position-relative `}>
            <img
                className="path-img"
                src={`${process.env.PUBLIC_URL}/images/feature/shape.png`}
                alt="images_not_found"
            />
            <div className="container custom-container mt-1">
                <div className="row g-0 align-items-center">
                    <div className="col-xl-6 col-lg-8 mx-auto mb-0 text-center">
                        <SectionTitle
                            classOption="title-section"
                            subTitle="WHY PENDA AGENCY!?"
                            title="We are <span class='text-primary'>different</span> because..."
                            excerptClassOption="mb-0"
                            // excerpt="Pleasure rationally encounter consequences that are extremely
                            // painful. Nor again is there anyone who loves or pursues or
                            // desires to obtain"
                        />
                        {/* <Button
                            classOption="btn btn-lg btn-dark btn-hover-dark"
                            text="Get Started"
                            path="/about"
                        /> */}
                    </div>

                    <div className="col-12">
                        <div id="grid" className="grid row mb-n1">
                            {HomeData[2].iconBox &&
                                HomeData[2].iconBox.map((single, key) => {
                                    return <IconBox key={key} data={single} />;
                                })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

IconBoxContainer.propTypes = {
    classOption: PropTypes.string,
};

IconBoxContainer.defaultProps = {
    classOption: "section-pb",
};

export default IconBoxContainer;
